import { UserProfile } from '../../types/auth.types';

const ACCESS_TOKEN_KEY = 'ecom_access_token';
const REFRESH_TOKEN_KEY = 'ecom_refresh_token';
const USER_DATA_KEY = 'ecom_user_data';

export const tokenService = {
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN_KEY),
  setAccessToken: (token: string) => localStorage.setItem(ACCESS_TOKEN_KEY, token),
  removeAccessToken: () => localStorage.removeItem(ACCESS_TOKEN_KEY),

  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),
  setRefreshToken: (token: string) => localStorage.setItem(REFRESH_TOKEN_KEY, token),
  removeRefreshToken: () => localStorage.removeItem(REFRESH_TOKEN_KEY),

  getUser: () => {
    const data = localStorage.getItem(USER_DATA_KEY);
    return data ? JSON.parse(data) : null;
  },
  setUser: (userData: UserProfile) => localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData)),
  removeUser: () => localStorage.removeItem(USER_DATA_KEY),

  clear: () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_DATA_KEY);
  }
};
